import React, { useState } from 'react';
import ImageLightbox from './ImageLightbox';
import imgLiving from '../assets/hero banner/2/WhatsApp Image 2026-04-09 at 5.23.48 PM(1).png';
import imgBedroom from '../assets/hero banner/2/WhatsApp Image 2026-04-09 at 5.23.49 PM (1)(1).jpeg';
import imgOffice from '../assets/hero banner/2/WhatsApp Image 2026-04-09 at 5.23.49 PM(1).png';
import imgDining from '../assets/hero banner/2/WhatsApp Image 2026-04-09 at 5.23.49 PM (2)(1).png';

const FeaturedCategories = () => {
  const [lightbox, setLightbox] = useState(null);

  const openImage = (src, alt) => {
    setLightbox({ src, alt });
  };

  const cardInteractiveProps = (src, alt) => ({
    role: 'button',
    tabIndex: 0,
    onClick: () => openImage(src, alt),
    onKeyDown: (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        openImage(src, alt);
      }
    },
  });

  return (
    <section className="py-16 sm:py-20 md:py-24 px-4 sm:px-8 md:px-16 bg-gradient-to-br from-gray-900 via-black to-gray-900">
      <div className="max-w-screen-2xl mx-auto">
        {/* Section Title */}
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-4 text-white">
            Featured Spaces
          </h2>
          <p className="text-base sm:text-lg md:text-xl max-w-2xl sm:max-w-3xl mx-auto text-gray-300">
            Explore our signature interior design collections crafted for modern living
          </p>
        </div>

        {/* Mobile First: Single Column Stack */}
        <div className="space-y-6 sm:space-y-8 md:hidden">
          {/* Living Room - Mobile */}
          <div
            {...cardInteractiveProps(imgLiving, 'Living room')}
            className="relative group overflow-hidden rounded-2xl bg-white h-[300px] shadow-xl cursor-pointer focus:outline-none focus-visible:ring-2 focus-visible:ring-amber-400 focus-visible:ring-offset-2 focus-visible:ring-offset-gray-900"
          >
            <img 
              className="w-full h-full object-contain object-center transition-transform duration-700 group-hover:scale-105 pointer-events-none" 
              alt="contemporary luxury living room with high ceiling, large canvas art, marble coffee table, and soft neutral tones" 
              src={imgLiving}
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent"></div>
            <div className="absolute bottom-6 left-6 text-white">
              <h3 className="text-2xl sm:text-3xl font-bold mb-2">Living Room</h3>
              <p className="uppercase tracking-widest text-sm opacity-90">The Heart of Home</p>
            </div>
          </div>

          {/* Bedroom - Mobile */}
          <div
            {...cardInteractiveProps(imgBedroom, 'Bedroom')}
            className="relative group overflow-hidden rounded-2xl bg-white h-[250px] shadow-xl cursor-pointer focus:outline-none focus-visible:ring-2 focus-visible:ring-amber-400 focus-visible:ring-offset-2 focus-visible:ring-offset-gray-900"
          >
            <img 
              className="w-full h-full object-contain object-center transition-transform duration-700 group-hover:scale-105 pointer-events-none" 
              alt="minimalist luxury bedroom with premium linen bedding, oak accents, and warm ambient lighting" 
              src={imgBedroom}
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent"></div>
            <div className="absolute bottom-6 left-6 text-white">
              <h3 className="text-xl sm:text-2xl font-bold mb-2">Bedroom</h3>
              <p className="uppercase tracking-widest text-sm opacity-90">Serene Sanctuaries</p>
            </div>
          </div>

          {/* Office - Mobile */}
          <div
            {...cardInteractiveProps(imgOffice, 'Office')}
            className="relative group overflow-hidden rounded-2xl bg-white h-[200px] shadow-xl cursor-pointer focus:outline-none focus-visible:ring-2 focus-visible:ring-amber-400 focus-visible:ring-offset-2 focus-visible:ring-offset-gray-900"
          >
            <img 
              className="w-full h-full object-contain object-center transition-transform duration-700 group-hover:scale-105 pointer-events-none" 
              alt="luxury home office desk with ergonomic walnut chair and professional minimalist setup" 
              src={imgOffice}
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent"></div>
            <div className="absolute bottom-4 left-4 text-white">
              <h3 className="text-lg sm:text-xl font-bold">Office</h3>
            </div>
          </div>

          {/* Dining - Mobile */}
          <div
            {...cardInteractiveProps(imgDining, 'Dining')}
            className="relative group overflow-hidden rounded-2xl bg-white h-[200px] shadow-xl cursor-pointer focus:outline-none focus-visible:ring-2 focus-visible:ring-amber-400 focus-visible:ring-offset-2 focus-visible:ring-offset-gray-900"
          >
            <img 
              className="w-full h-full object-contain object-center transition-transform duration-700 group-hover:scale-105 pointer-events-none" 
              alt="elegant dining area with mid-century modern table and chairs under designer lighting" 
              src={imgDining}
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent"></div>
            <div className="absolute bottom-4 left-4 text-white">
              <h3 className="text-lg sm:text-xl font-bold">Dining</h3>
            </div>
          </div>
        </div>

        {/* Desktop Layout */}
        <div className="hidden md:grid grid-cols-1 md:grid-cols-12 gap-6 sm:gap-8 h-auto md:h-[800px]">
          {/* Living Room - Large */}
          <div
            {...cardInteractiveProps(imgLiving, 'Living room')}
            className="md:col-span-7 relative group overflow-hidden rounded-2xl bg-white h-[400px] md:h-auto shadow-xl border border-gray-800 cursor-pointer focus:outline-none focus-visible:ring-2 focus-visible:ring-amber-400 focus-visible:ring-offset-2 focus-visible:ring-offset-gray-900"
          >
            <img 
              className="w-full h-full object-contain object-center transition-transform duration-700 group-hover:scale-105 pointer-events-none" 
              alt="contemporary luxury living room with high ceiling, large canvas art, marble coffee table, and soft neutral tones" 
              src={imgLiving}
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
            <div className="absolute bottom-8 left-8 text-white">
              <h3 className="text-3xl md:text-4xl font-bold mb-2">Living Room</h3>
              <p className="uppercase tracking-widest text-sm opacity-90">The Heart of Home</p>
            </div>
          </div>

          {/* Right Column */}
          <div className="md:col-span-5 grid grid-rows-2 gap-6 sm:gap-8 h-auto md:h-full">
            {/* Bedroom */}
            <div
              {...cardInteractiveProps(imgBedroom, 'Bedroom')}
              className="relative group overflow-hidden rounded-2xl bg-white h-[300px] shadow-xl border border-gray-800 cursor-pointer focus:outline-none focus-visible:ring-2 focus-visible:ring-amber-400 focus-visible:ring-offset-2 focus-visible:ring-offset-gray-900"
            >
              <img 
                className="w-full h-full object-contain object-center transition-transform duration-700 group-hover:scale-105 pointer-events-none" 
                alt="minimalist luxury bedroom with premium linen bedding, oak accents, and warm ambient lighting" 
                src={imgBedroom}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
              <div className="absolute bottom-6 left-6 text-white">
                <h3 className="text-2xl md:text-3xl font-bold mb-1">Bedroom</h3>
                <p className="uppercase tracking-widest text-sm opacity-90">Serene Sanctuaries</p>
              </div>
            </div>

            {/* Office and Dining Grid */}
            <div className="grid grid-cols-2 gap-4 md:gap-6">
              {/* Office */}
              <div
                {...cardInteractiveProps(imgOffice, 'Office')}
                className="relative group overflow-hidden rounded-2xl bg-white h-[250px] shadow-xl border border-gray-800 cursor-pointer focus:outline-none focus-visible:ring-2 focus-visible:ring-amber-400 focus-visible:ring-offset-2 focus-visible:ring-offset-gray-900"
              >
                <img 
                  className="w-full h-full object-contain object-center transition-transform duration-700 group-hover:scale-105 pointer-events-none" 
                  alt="luxury home office desk with ergonomic walnut chair and professional minimalist setup" 
                  src={imgOffice}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
                <div className="absolute bottom-4 left-4 text-white">
                  <h3 className="text-lg md:text-xl font-bold">Office</h3>
                </div>
              </div>

              {/* Dining */}
              <div
                {...cardInteractiveProps(imgDining, 'Dining')}
                className="relative group overflow-hidden rounded-2xl bg-white h-[250px] shadow-xl border border-gray-800 cursor-pointer focus:outline-none focus-visible:ring-2 focus-visible:ring-amber-400 focus-visible:ring-offset-2 focus-visible:ring-offset-gray-900"
              >
                <img 
                  className="w-full h-full object-contain object-center transition-transform duration-700 group-hover:scale-105 pointer-events-none" 
                  alt="elegant dining area with mid-century modern table and chairs under designer lighting" 
                  src={imgDining}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
                <div className="absolute bottom-4 left-4 text-white">
                  <h3 className="text-lg md:text-xl font-bold">Dining</h3>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ImageLightbox
        isOpen={!!lightbox}
        src={lightbox?.src ?? null}
        alt={lightbox?.alt ?? ''}
        onClose={() => setLightbox(null)}
      />
    </section>
  );
};

export default FeaturedCategories;
